'use client';
import { ChevronDown, ChevronUp } from '@v2/ui/Icon/Arrow';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@v2/ui/Command/Command';
import { Popover, PopoverContent, PopoverTrigger } from '@v2/ui/Popover';
import clsx from 'clsx';
import { useState } from 'react';

export const OpponentsDropdownFilter = ({
  teams,
  selectedValue,
  onOpponentChange,
  onSearch,
  defaultLabel = 'All opponents',
  compactMobile = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const buttonTriggerClassname = clsx(
    'flex shrink-0 border border-gray-200 rounded-lg items-center gap-x-2 h-9',
    compactMobile
      ? 'min-w-0 px-3 text-sm md:h-12 md:min-w-32 md:px-4 md:text-base'
      : 'min-w-32 px-4 md:h-12',
    {
      'bg-gray-800 text-white': !!selectedValue,
    }
  );

  const onChangeSearchInput = (value: string) => {
    setSearchValue(value);
    onSearch(value.trimStart());
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={buttonTriggerClassname}>
          {selectedValue?.team ?? defaultLabel}
          {isOpen ? <ChevronUp size="20" /> : <ChevronDown size="20" />}
        </button>
      </PopoverTrigger>

      <PopoverContent className="p-0" align="start">
        <Command className="rounded-lg">
          <CommandInput
            placeholder="Search opponents..."
            value={searchValue}
            onValueChange={onChangeSearchInput}
            onClose={() => setIsOpen(false)}
            autoFocus
          />
          <CommandList>
            <CommandEmpty>No opponents found.</CommandEmpty>
            <CommandGroup>
              {teams?.map((item) => (
                <CommandItem
                  key={item.teamId}
                  onSelect={() => {
                    onOpponentChange(item);
                    setIsOpen(false);
                  }}
                  className="cursor-pointer"
                >
                  {item.team}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
